import * as React from "react";
import styled, { css } from "styled-components";
import { Well } from "components/bootstrap";
const PASSWORD_PLACEHOLDER = "********";
const RegularField = ({ id, value, name }) => {
  let finalValue;
  if (value === null || value === void 0 || value === "" || Array.isArray(value) && value.length === 0) {
    finalValue = /* @__PURE__ */ React.createElement("i", null, "<empty>");
  } else {
    finalValue = Array.isArray(value) ? value.join(", ") : String(value);
  }
  return /* @__PURE__ */ React.createElement("li", { key: `${id}-${name}` }, /* @__PURE__ */ React.createElement("div", { className: "key" }, name, ":"), " ", /* @__PURE__ */ React.createElement("div", { className: "value" }, finalValue));
};
const InlineBinaryField = ({ id, value, name }) => {
  let finalValue;
  if (value === null || value === void 0 || value === "") {
    finalValue = /* @__PURE__ */ React.createElement("i", null, "<empty>");
  } else {
    finalValue = /* @__PURE__ */ React.createElement("i", null, "<uploaded file content>");
  }
  return /* @__PURE__ */ React.createElement("li", { key: `${id}-${name}` }, /* @__PURE__ */ React.createElement("div", { className: "key" }, name, ":"), " ", /* @__PURE__ */ React.createElement("div", { className: "value" }, finalValue));
};
const EncryptedField = ({ id, value, name }) => {
  let finalValue;
  if (!value.is_set) {
    finalValue = /* @__PURE__ */ React.createElement("i", null, "<empty>");
  } else {
    finalValue = PASSWORD_PLACEHOLDER;
  }
  return /* @__PURE__ */ React.createElement("li", { key: `${id}-${name}` }, /* @__PURE__ */ React.createElement("div", { className: "key" }, name, ":"), " ", /* @__PURE__ */ React.createElement("div", { className: "value" }, finalValue));
};
const PasswordField = ({ id, name }) => /* @__PURE__ */ React.createElement("li", { key: `${id}-${name}` }, /* @__PURE__ */ React.createElement("div", { className: "key" }, name, ":"), " ", /* @__PURE__ */ React.createElement("div", { className: "value" }, PASSWORD_PLACEHOLDER));
const isPasswordField = (field) => (field == null ? void 0 : field.type) === "text" && (field.attributes.includes("is_password") || field.attributes.includes("is_sensitive"));
const Configuration = ({
  id: _id,
  config,
  typeDefinition = void 0
}) => {
  if (!config) {
    return "";
  }
  const formattedItems = Object.keys(config).sort().map((key) => {
    var _a;
    const value = config[key];
    const requestedConfiguration = (_a = typeDefinition == null ? void 0 : typeDefinition.requested_configuration) == null ? void 0 : _a[key];
    if (requestedConfiguration && "is_encrypted" in requestedConfiguration && requestedConfiguration.is_encrypted) {
      return /* @__PURE__ */ React.createElement(EncryptedField, { key, id: _id, value, name: key });
    }
    if (isPasswordField(requestedConfiguration)) {
      return /* @__PURE__ */ React.createElement(PasswordField, { key, id: _id, name: key });
    }
    if ((requestedConfiguration == null ? void 0 : requestedConfiguration.type) === "inline_binary") {
      return /* @__PURE__ */ React.createElement(InlineBinaryField, { key, id: _id, value, name: key });
    }
    return /* @__PURE__ */ React.createElement(RegularField, { key, id: _id, value, name: key });
  });
  if (formattedItems.length < 1) {
    formattedItems.push(/* @__PURE__ */ React.createElement("li", { key: "placeholder" }, "-- no configuration --"));
  }
  return /* @__PURE__ */ React.createElement("ul", null, formattedItems);
};
const StyledWell = styled(Well)(
  ({ theme }) => css`
    margin-top: 5px;
    margin-bottom: 0;
    padding: 9px;
    font-family: ${theme.fonts.family.monospace};
    overflow-wrap: break-word;

    ul {
      padding: 0;
      margin: 0;
    }

    white-space: pre-line;

    .configuration-section {
      margin-bottom: 10px;
    }

    li:not(:last-child) {
      margin-bottom: 5px;
    }

    .key {
      display: inline;
    }

    .alert-callback .key {
      display: inline-block;
      min-width: 140px;
      vertical-align: top;
    }

    .value {
      display: inline;
    }

    .alert-callback .value {
      display: inline-block;
    }
  `
);
const ConfigurationWell = ({ id, configuration, typeDefinition = void 0 }) => /* @__PURE__ */ React.createElement(StyledWell, { bsSize: "small" }, /* @__PURE__ */ React.createElement(Configuration, { id, config: configuration, typeDefinition }));
export default ConfigurationWell;
